export type Invite = {
  code: string;
  invitee_email?: string;
  // Canonical onboarding URL, rebuilt server-side from the code (same source
  // as create + /send). The console reads this through — it never mints one.
  invite_url?: string;
  // The product this invite was minted for (dec-product-separation-invite-mode).
  // Absent on invites minted before ee1b412c — those redeem mode-less.
  mode_id?: string | null;
  created_at?: string;
  created_by?: string;
  expires_at?: string;
  consumed_at?: string | null;
  consumed_by_user_ref?: string | null;
  revoked?: boolean;
};

import type { PeriReviewMode, StrataStage, StrataSubbranch } from './periReview';

/** A tester's perimenopause-review cohort assignment, or null if not in the
 *  cohort. Source of truth is the peri_review_cohort store; surfaced on the
 *  tester list projection (joined by user_ref). */
export type TesterCohort = {
  review_mode: PeriReviewMode;
  strata_stage: StrataStage;
  strata_subbranch: StrataSubbranch;
};

export type Tester = {
  user_ref: string;
  name?: string;
  email?: string;
  created_at?: string;
  last_active?: string | null;
  documents_ingested?: number;
  board_sessions?: number;
  onboarding_complete?: boolean;
  revoked?: boolean;
  board_rate_cap_override?: number | null;
  cohort?: TesterCohort | null;
};

export type InviteStatus = 'revoked' | 'redeemed' | 'expired' | 'pending';

export function inviteStatus(i: Invite): InviteStatus {
  if (i.revoked) return 'revoked';
  if (i.consumed_at) return 'redeemed';
  if (i.expires_at && new Date(i.expires_at).getTime() < Date.now()) return 'expired';
  return 'pending';
}

export const INVITE_STATUS_HEX: Record<InviteStatus, string> = {
  pending: '#F2A93B', redeemed: '#2BBAA8', revoked: '#8A94A6', expired: '#8A94A6',
};
